// extracted by mini-css-extract-plugin
export var headline = "actionsMain-module--headline--3ZGTE";
export var title = "actionsMain-module--title--10yXn";
export var body = "actionsMain-module--body--2A7U0";
export var actionContainer = "actionsMain-module--actionContainer--2vx3a";
export var price = "actionsMain-module--price--21hy5";
export var priceBefore = "actionsMain-module--priceBefore--2isXQ";